var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _rect6, _ellipse, _circle, _rect7, _rect8, _rect9, _rect10, _path9, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path10, _rect21, _rect22, _rect23, _rect24, _rect25, _circle2, _circle3, _circle4, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceBookReading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 143,
    viewBox: "0 0 281 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 38,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 46,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 46,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 118C106.068 119.679 104.679 121.068 103 122C104.679 122.932 106.068 124.321 107 126C107.932 124.321 109.321 122.932 111 122C109.321 121.068 107.932 119.679 107 118Z",
    fill: "#FFEBBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 23C92.0684 24.6788 90.6788 26.0684 89 27C90.6788 27.9316 92.0684 29.3212 93 31C93.9316 29.3212 95.3212 27.9316 97 27C95.3212 26.0684 93.9316 24.6788 93 23Z",
    fill: "#FFEBBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242 127C241.068 128.679 239.679 130.068 238 131C239.679 131.932 241.068 133.321 242 135C242.932 133.321 244.321 131.932 246 131C244.321 130.068 242.932 128.679 242 127Z",
    fill: "#FFEBBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161 0C160.534 0.839421 159.839 1.53421 159 2C159.839 2.46579 160.534 3.16058 161 4C161.466 3.16058 162.161 2.46579 163 2C162.161 1.53421 161.466 0.839421 161 0Z",
    fill: "#FFEBBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C1.53421 4.83942 0.839411 5.53421 0 6C0.839411 6.46579 1.53421 7.16058 2 8C2.46579 7.16058 3.16059 6.46579 4 6C3.16059 5.53421 2.46579 4.83942 2 4Z",
    fill: "#FFEBBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 135C17.5342 135.839 16.8394 136.534 16 137C16.8394 137.466 17.5342 138.161 18 139C18.4658 138.161 19.1606 137.466 20 137C19.1606 136.534 18.4658 135.839 18 135Z",
    fill: "#FFEBBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171 139C170.534 139.839 169.839 140.534 169 141C169.839 141.466 170.534 142.161 171 143C171.466 142.161 172.161 141.466 173 141C172.161 140.534 171.466 139.839 171 139Z",
    fill: "#FFEBBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 40L188 33",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 46,
    width: 24,
    height: 60,
    rx: 1.5,
    fill: "#FFC844"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 22,
    width: 21,
    height: 84,
    rx: 1.5,
    fill: "#A1498C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 22,
    y: 32.5,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 55,
    cy: 76,
    rx: 6,
    ry: 18,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 29.5,
    cy: 87.25,
    r: 6.75,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 106,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#F6E0CD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 106,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#F6E0CD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 114,
    width: 80,
    height: 4,
    rx: 2,
    fill: "#F6E0CD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 92,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 108L71.5 112L78.5 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 40,
    width: 30,
    height: 66,
    rx: 1.5,
    fill: "#FFC844"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 28,
    width: 15,
    height: 78,
    rx: 1.5,
    fill: "#F15651"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 122.5,
    y: 58,
    width: 15,
    height: 30,
    rx: 7.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 148,
    y: 66.25,
    width: 15,
    height: 1.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 148,
    y: 34,
    width: 15,
    height: 1.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 148,
    y: 98.5,
    width: 15,
    height: 1.5,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 148,
    y: 95.5,
    width: 15,
    height: 1.5,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 122.5,
    y: 94,
    width: 15,
    height: 1.5,
    rx: 0.75,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 148,
    y: 37,
    width: 15,
    height: 1.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 92,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 108L167.5 112L174.5 104",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 42,
    width: 24,
    height: 72,
    rx: 1.5,
    fill: "#A1498C"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 246,
    y: 54,
    width: 2,
    height: 48,
    rx: 1,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 24,
    width: 24,
    height: 90,
    rx: 1.5,
    fill: "#F15651"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 213,
    y: 45,
    width: 14,
    height: 48,
    rx: 1.5,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 92,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#75BE74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 108,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 108,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 108,
    r: 2,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266 35.5L274 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceBookReading);
export default __webpack_public_path__ + "static/media/persistence-book-reading.c93ed433b77ff01c495252ea359f2698.svg";
export { ForwardRef as ReactComponent };